import { Tutorial } from '../components/splide'

const listOfTutorials = [
  'dashboard',
  'disputed',
  'invoices',
  'my-account',
  'operations',
  'support',
  'tags',
  'trips',
]

const clearCookies = () => {
  listOfTutorials.forEach((tutorial) => {
    document.cookie = `tutorial-${tutorial}=1; expires=Thu, 18 Dec 2013 12:00:00 UTC`
  })
}

const setCookiePolicy = (tutorial) => {
  let expiryDate = new Date()
  expiryDate.setMonth(expiryDate.getMonth() + 11)

  document.cookie = `tutorial-${tutorial}=1; expires=${expiryDate.toGMTString()}`
}

const tutorials = () => {
  // clearCookies()

  const cookies = document.cookie.split(";")

  listOfTutorials.forEach((tutorial) => {
    if (cookies.indexOf(`tutorial-${tutorial}=1`) < 0 && cookies.indexOf(` tutorial-${tutorial}=1`) < 0) {
      $.fancybox.open($(`#tutorial-${tutorial}`), {
        afterShow: () => {
          Tutorial()
        },
        afterClose: () => {
          setCookiePolicy(tutorial)
        }
      })
    }
  })
}
export default tutorials
